import type { Layer, TagsManager } from 'dxf-writer'
import DatabaseObject from 'dxf-writer/src/DatabaseObject.js'

/**
 * DXF 直线（LINE）实体，表示二维两点连线。
 */
export default class Line extends DatabaseObject {
  /** 所属图层 */
  layer!: Layer
  /** 线型名称，默认跟随图层 */
  lineType: string = 'ByLayer'
  /** 线宽，单位百分之毫米；-1 表示跟随图层 */
  lineWidth: number = -1
  /** 真彩色 RGB 整数，undefined 表示不写入 */
  trueColor: number | undefined

  constructor(
    public start: { x: number; y: number },
    public end: { x: number; y: number }
  ) {
    super(['AcDbEntity', 'AcDbLine'])
  }
  /**
   * 写入 LINE 组码序列。
   *
   * @param manager - DXF 标签写入器
   */
  tags(manager: TagsManager) {
    manager.push(0, 'LINE')
    super.tags(manager)
    manager.push(8, this.layer.name)
    manager.push(6, this.lineType)
    manager.push(62, 256)
    manager.push(370, this.lineWidth)
    if (this.trueColor !== undefined) {
      manager.push(420, this.trueColor)
    }
    manager.point(this.start.x, this.start.y)
    manager.push(11, this.end.x)
    manager.push(21, this.end.y)
    manager.push(31, 0)
  }
}
